import { render, staticRenderFns } from "./studentProfile.vue?vue&type=template&id=95c080f0&scoped=true&"
import script from "./studentProfile.vue?vue&type=script&lang=js&"
export * from "./studentProfile.vue?vue&type=script&lang=js&"
import style0 from "./studentProfile.vue?vue&type=style&index=0&id=95c080f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c080f0",
  null
  
)

export default component.exports